import { merge } from 'lodash';

import { Injectable } from '@angular/core';

import { ISnListQueryParameters } from '@lib/api';
import { SnTag } from '@lib/api/entities';
import { SnTagsAPI } from '@lib/api/services';
import { ISnHttpSelectFormFieldConfig } from '@lib/form/http-select';
import { ISnInputFormFieldConfig } from '@lib/form/input';
import { t } from '@lib/translation';

@Injectable({ providedIn: 'root' })
export class SnTagFieldGeneratorService {
  constructor(private readonly _tagsAPI: SnTagsAPI) {}

  public getTagSelectField(
    fieldConfig?: Partial<ISnHttpSelectFormFieldConfig<SnTag>>,
    setParams?: ISnListQueryParameters,
  ): ISnHttpSelectFormFieldConfig<SnTag> {
    const baseFieldConfig: ISnHttpSelectFormFieldConfig<SnTag> = {
      key: 'tag',
      type: 'http-select',
      templateOptions: {
        label: t('common.tags'),
        floatLabel: 'always',
        placeholder: t('common.none'),
        valueProp: 'id',
        labelProp: 'name',
        infinityScroll: true,
        fetchDataFn: (params: ISnListQueryParameters) =>
          this._tagsAPI.getTagList({ ...params, ...setParams }),
      },
    };

    return merge(baseFieldConfig, fieldConfig);
  }

  public getNameField(fieldConfig?: Partial<ISnInputFormFieldConfig>): ISnInputFormFieldConfig {
    const baseFieldConfig: ISnInputFormFieldConfig = {
      key: 'name',
      type: 'input',
      templateOptions: {
        label: t('common.name'),
        placeholder: t('common.enterName'),
      },
    };

    return merge(baseFieldConfig, fieldConfig);
  }
}
